import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import { Link } from "react-scroll";
const Sidebar = (props) => {
  return (
    <div
      className={`bg-black transition-all ease-in-out duration-200 pb-5 ${
        props.sidebarState ? "-translate-x-52" : "translate-x-40"
      } top-0 fixed w-screen h-screen`}
    >
      <div className="w-60 px-1 py-7 flex flex-none justify-end">
        <button onClick={() => props.updateSidebarState(false)}>
          <IoCloseSharp
            className="text-white hover:text-egyptian-gold transition-all ease-in-out duration-100"
            size="40px"
          />
        </button>
      </div>
      <div className="w-60 h-5/6 flex flex-none flex-col justify-between">
        <ul className="flex flex-none items-start text-lg pl-4 flex-col">
          <li className="font-content font-medium">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="sidebarLinkStyle"
              to="home"
              spy={true}
              duration={500}
              smooth={true}
            >
              Home&ensp;&nbsp;
            </Link>
          </li>
          <li className="font-content font-medium">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="sidebarLinkStyle"
              to="about"
              spy={true}
              duration={500}
              smooth={true}
            >
              About
            </Link>
          </li>
          <li className="font-content font-medium">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="sidebarLinkStyle"
              to="roadmap"
              spy={true}
              duration={500}
              smooth={true}
            >
              Roadmap
            </Link>
          </li>
          <li className="font-content font-medium">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="sidebarLinkStyle"
              to="faq"
              spy={true}
              duration={500}
              smooth={true}
            >
              FAQ
            </Link>
          </li>
          <li className="font-content font-medium">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="sidebarLinkStyle"
              to="mint"
              spy={true}
              duration={500}
              smooth={true}
            >
              How to Mint
            </Link>
          </li>
          <li className="font-content font-medium">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="sidebarLinkStyle"
              to="team"
              spy={true}
              duration={500}
              smooth={true}
            >
              Team
            </Link>
          </li>
          <li className="font-content font-medium mt-2">
            <Link
              onClick={() => props.updateSidebarState(false)}
              className="bg-white hover:bg-egyptian-gold transition-all text-black px-2.5 py-1 ease-in-out duration-200 cursor-pointer rounded-full"
              to="social"
              spy={true}
              duration={500}
              smooth={true}
            >
              Join Us
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Sidebar;
